import Swal from 'sweetalert2'

export const apiErrorHandler = (e, default_token = false) => {
  const responseData = e.response?.data

  if (e.message === 'Network Error') {
    Swal.fire({
      icon: 'error',
      title: 'لطفا اتصال اینترنت را بررسی فرمایید',
      allowOutsideClick: false,
    })
    return { status: null, error: e.message }
  }

  if (e.response?.status === 400) {
    if (responseData?.errors) {
      // Swal.fire({
      //   icon: 'error',
      //   text: '.لطفا خطاهای به وجود آمده را رفع کنید',
      // })
      return { status: 400, error: responseData.errors }
    } else {
      return { status: 400, error: responseData?.message }
    }
  } else if (e.response?.status === 403) {
    if (responseData?.errors?.verify_code) {
      return { status: 403, error: responseData.errors }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'خطای دسترسی',
        text: 'شما به این بخش دسترسی ندارید',
      })
      return { status: 403 }
    }
  } else if (e.response?.status === 404) {
    window.location.pathname = '/404'
    return { status: 404 }
  } else if (e.response?.status === 500 || e.response?.status === 503) {
    window.location.pathname = '/500'
    return { status: e.response.status }
  } else if (e.response?.status === 401) {
    Swal.fire({
      icon: 'error',
      title: 'عدم دسترسی',
      text: 'احراز هویت نامعتبر',
    })
    window.location.replace(default_token ? '/' : '/admin')
    localStorage.removeItem('Token')
    return { status: 401 }
  }

  return { status: null, error: e?.message }
}
